//#region src/payment/const.ts
/**
* Hand-written mirrors of GraphQL-codegen enums so pixai-contract can own
* payment wire-format types without depending on pixai-server's
* `generated/graphql.ts`. A parity test in pixai-server
* (`test/contract/enum-sync.test.ts`) asserts the full key→value mapping
* stays in sync with the codegen output; bumping the GraphQL schema must
* also bump these.
*/
const Currency = {
	Eur: "EUR",
	Jpy: "JPY",
	Usd: "USD"
};
const PaymentItemType = {
	ExtraPackage: "EXTRA_PACKAGE",
	OneTimeMembership: "ONE_TIME_MEMBERSHIP",
	Plan: "PLAN"
};
const Interval = {
	Month: "MONTH",
	Year: "YEAR"
};
const ExtraPackageBoostType = {
	Campaign: "CAMPAIGN",
	Coupon: "COUPON",
	Membership: "MEMBERSHIP",
	Tier: "TIER"
};
const ExtraPackageCampaignCategory = {
	EventBased: "EVENT_BASED",
	Monthly: "MONTHLY"
};
//#endregion
export { Currency, ExtraPackageBoostType, ExtraPackageCampaignCategory, Interval, PaymentItemType };
